<script setup>
import { ref, onBeforeUnmount, onBeforeMount } from "vue";
import { useStore } from "vuex";
import { useRouter } from "vue-router";
import ArgonInput from "@/components/ArgonInput.vue";
import ArgonSwitch from "@/components/ArgonSwitch.vue";
import ArgonButton from "@/components/ArgonButton.vue";
import { useAuth } from "@/composables/useAuth";

const body = document.body; // ✅ fix
const store = useStore();
const router = useRouter();
const { login } = useAuth();

// 🔥 estados reactivos
const email = ref("");
const password = ref("");
const error = ref("");
const loading = ref(false); // ✅ nuevo

// lifecycle
onBeforeMount(() => {
  store.state.hideConfigButton = true;
  store.state.showNavbar = false;
  store.state.showSidenav = false;
  store.state.showFooter = false;
  body.classList.remove("bg-gray-100");
});

onBeforeUnmount(() => {
  store.state.hideConfigButton = false;
  store.state.showNavbar = true;
  store.state.showSidenav = true;
  store.state.showFooter = true;
  body.classList.add("bg-gray-100");
});

// ✅ submit mejorado
const handleSubmit = async () => {
  if (loading.value) return;

  // ✅ validación básica
  if (!email.value || !password.value) {
    error.value = "Debes completar todos los campos";
    return;
  }

  loading.value = true;
  error.value = "";

  try {
    await login(email.value, password.value);
    router.push("/dashboard");
  } catch (err) {
    error.value = err.response?.data?.error || "Credenciales inválidas";
  } finally {
    loading.value = false;
  }
};
</script>

<template>
  <div class="container top-0 position-sticky z-index-sticky">
    <div class="row">
      <div class="col-12">
        <!-- navbar -->
      </div>
    </div>
  </div>

  <main class="mt-0 main-content">
    <section>
      <div class="page-header min-vh-100">
        <div class="container">
          <div class="row">
            <div class="mx-auto col-xl-4 col-lg-5 col-md-7 d-flex flex-column mx-lg-0">
              <div class="card card-plain">
                <div class="pb-0 card-header text-start">
                  <h4 class="font-weight-bolder">Iniciar sesión</h4>
                  <p class="mb-0">
                    Introduce tu correo electrónico y contraseña para iniciar sesión.
                  </p>
                </div>

                <div class="card-body">
                  <form @submit.prevent="handleSubmit">
                    <div class="mb-3">
                      <argon-input
                        v-model="email"
                        type="email"
                        placeholder="Correo"
                        size="lg"
                      />
                    </div>

                    <div class="mb-3">
                      <argon-input
                        v-model="password"
                        type="password"
                        placeholder="Contraseña"
                        size="lg"
                      />
                    </div>

                    <div class="d-flex justify-content-between align-items-center">
                      <argon-switch id="rememberMe">
                        Recuérdame
                      </argon-switch>

                      <router-link
                        to="/forgot-password"
                        class="text-sm text-success text-gradient font-weight-bold"
                      >
                        ¿Olvidaste tu contraseña?
                      </router-link>
                    </div>

                    <div class="text-center">
                      <argon-button
                        class="mt-4"
                        variant="gradient"
                        color="success"
                        fullWidth
                        size="lg"
                        type="submit"
                        :disabled="loading"
                      >
                        {{ loading ? "Ingresando..." : "Iniciar sesión" }}
                      </argon-button>
                    </div>

                    <!-- 👇 error dinámico -->
                    <p v-if="error" class="text-danger mt-2 text-center">
                      {{ error }}
                    </p>
                  </form>
                </div>

              </div>
            </div>

            <div
              class="top-0 my-auto text-center col-6 d-lg-flex d-none h-100 pe-0 position-absolute end-0 justify-content-center flex-column"
            >
              <div
                class="position-relative bg-gradient-primary h-100 m-3 px-7 border-radius-lg d-flex flex-column justify-content-center overflow-hidden"
                style="
                  background-image: url('https://raw.githubusercontent.com/creativetimofficial/public-assets/master/argon-dashboard-pro/assets/img/signin-ill.jpg');
                  background-size: cover;
                "
              >
                <span class="mask bg-gradient-success opacity-6"></span>

                <h4 class="mt-5 text-white font-weight-bolder position-relative">
                  "Attention is the new currency"
                </h4>

                <p class="text-white position-relative">
                  The more effortless the writing looks, the more effort the
                  writer actually put into the process.
                </p>
              </div>
            </div>

          </div>
        </div>
      </div>
    </section>
  </main>
</template>